var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.25 356.25V332.5H237.5V308.75H213.75V332.5V356.25H237.5V380H261.25H285V356.25H261.25Z",
    fill: "#E1E5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 356.25H213.75V380H237.5V356.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 356.25V332.5H166.25H142.5V356.25H166.25V380H190H213.75V356.25H190Z",
    fill: "#E1E5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 356.25H142.5V380H166.25V356.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.75 356.25V332.5H95V356.25V380H118.75H142.5V356.25H118.75Z",
    fill: "#E1E5ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 332.5H332.5V356.25H356.25V332.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 332.5H118.75V356.25H142.5V332.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95 332.5H118.75V308.75H95V285H71.25V261.25H47.5V285H23.75H0V308.75H23.75H47.5H71.25V332.5V356.25V380H95V356.25V332.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 332.5V308.75H0V380H71.25V332.5ZM47.5 356.25H23.75V332.5H47.5V356.25Z",
    fill: "#E1E5ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 332.5H23.75V356.25H47.5V332.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 308.75H308.75V380H380V308.75H332.5ZM356.25 356.25H332.5V332.5H356.25V356.25Z",
    fill: "#E1E5ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.25 308.75H237.5V332.5H261.25V308.75Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 308.75H118.75V332.5H142.5V308.75Z",
    fill: "#E1E5ED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 285H308.75H285V308.75V332.5H261.25V356.25H285V380H308.75V356.25V332.5V308.75H332.5H356.25H380V285H356.25H332.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.25 261.25H237.5V285V308.75H261.25V332.5H285V308.75V285H261.25V261.25Z",
    fill: "#E1E5ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.75 261.25H95H71.25V285H95V308.75H118.75V285V261.25Z",
    fill: "#E1E5ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 285V261.25H23.75V237.5H47.5V261.25H71.25V237.5H95V213.75H71.25V190H47.5V213.75H23.75V190H0V213.75V237.5V261.25V285H23.75H47.5Z",
    fill: "#E1E5ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 237.5H332.5V261.25H356.25V237.5Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 237.5H23.75V261.25H47.5V237.5Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M380 213.75H356.25V237.5H380V213.75Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75 213.75H285V237.5H308.75V213.75Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 190H23.75V213.75H47.5V190Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M380 166.25H356.25V190H380V166.25Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 166.25H332.5V190H308.75V166.25H285V190H261.25V213.75V237.5H285V213.75H308.75V237.5H285V261.25V285H308.75H332.5H356.25H380V261.25V237.5H356.25V261.25H332.5V237.5H356.25V213.75H380V190H356.25V166.25Z",
    fill: "#E1E5ED"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 166.25H308.75V190H332.5V166.25Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 190H47.5V166.25H71.25V142.5H47.5V118.75V95H23.75H0V118.75H23.75V142.5H0V166.25H23.75V190Z",
    fill: "#E1E5ED"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 166.25H0V190H23.75V166.25Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 142.5H332.5V166.25H356.25V142.5Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 142.5H308.75V166.25H332.5V142.5Z",
    fill: "#E1E5ED"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 142.5V166.25H190V142.5V118.75H166.25V142.5Z",
    fill: "#E1E5ED"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 118.75H308.75V142.5H332.5V118.75Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75 118.75H285V142.5H308.75V118.75Z",
    fill: "#E1E5ED"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 118.75H0V142.5H23.75V118.75Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M380 95H356.25V118.75H380V95Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 95H332.5V71.25H308.75V95V118.75H332.5V142.5H356.25V166.25H380V142.5V118.75H356.25V95Z",
    fill: "#E1E5ED"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M213.75 95H190V118.75H213.75V95Z",
    fill: "#E1E5ED"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M190 95H166.25V118.75H190V95Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95 95H71.25V118.75H95V95Z",
    fill: "#E1E5ED"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 71.25H332.5V95H356.25V71.25Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 95V118.75V142.5H71.25V166.25H47.5V190H71.25V213.75H95V237.5H71.25V261.25H95H118.75V285V308.75H142.5V332.5H166.25H190V356.25H213.75V332.5V308.75H237.5V285V261.25H261.25V285H285V261.25V237.5H261.25V213.75V190H285V166.25H308.75V142.5H285V118.75H308.75V95V71.25H332.5V47.5H308.75H285H261.25V23.75H237.5V47.5V71.25H213.75H190V95H213.75V118.75H190V142.5V166.25H166.25V142.5V118.75H142.5V95H118.75H95V118.75H71.25V95H95V71.25H118.75V47.5H95V23.75V0H71.25V23.75V47.5V71.25H47.5H23.75H0V95H23.75H47.5Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 47.5V71.25H356.25V95H380V71.25V47.5H356.25H332.5Z",
    fill: "#E1E5ED"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 47.5H142.5V71.25H166.25V47.5Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 71.25H71.25V0H0V71.25H47.5ZM23.75 23.75H47.5V47.5H23.75V23.75Z",
    fill: "#E1E5ED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M190 23.75V47.5H166.25V71.25H142.5V47.5H118.75V71.25H95V95H118.75H142.5V118.75H166.25V95H190V71.25H213.75H237.5V47.5V23.75H261.25V47.5H285H308.75H332.5V23.75V0H308.75V23.75H285V0H261.25H237.5H213.75V23.75H190Z",
    fill: "#E1E5ED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M190 23.75H166.25V47.5H190V23.75Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 23.75H118.75V47.5H142.5V23.75Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47.5H118.75V23.75H142.5V47.5H166.25V23.75H190V0H166.25H142.5H118.75H95V23.75V47.5Z",
    fill: "#E1E5ED"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 23.75H23.75V47.5H47.5V23.75Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M380 0H356.25V23.75H380V0Z",
    fill: "#E1E5ED"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 0H332.5V23.75V47.5H356.25H380V23.75H356.25V0Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75 0H285V23.75H308.75V0Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M213.75 0H190V23.75H213.75V0Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M221.589 142.501L213.75 163.574L195.084 213.751L190 227.419L180.238 253.659L166.25 218.088L155.204 190.001L142.5 157.695L140.694 153.102L100.363 153.102L158.869 301.876L180.751 301.876L202.632 301.876L261.25 144.301L261.919 142.501L285 80.4569L285.867 78.1254H285L245.537 78.125L237.5 99.7296L221.589 142.501Z",
    fill: "#477BE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile_logo.835cfa043a02a7df6bac38eec072c313.svg";
export { ForwardRef as ReactComponent };